module.exports = __webpack_public_path__ + "7fe693d9ad44a3b716aa9c48933bc102.svg";